// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-cart-noitem__caption[data-v-513da4b0]{font-size:18px}", ""]);
// Exports
module.exports = exports;
